// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1699493286
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { DescribedItem } from './models/common/describeditem';
import { DescribedItemLookup } from './models/common/describeditemlookup';

@Injectable({
  providedIn: 'root',
})
export class DescribedItemsApiService {
  constructor(protected http: HttpClient) {}

  getDescribedItems(type: string): Observable<DescribedItem[]> {
    const url = environment.chiliSauceApiRoot + `/api/DescribedItems/${type}`;
    return this.http.get<DescribedItem[]>(url);
  }

  getAllDescribedItems(): Observable<DescribedItemLookup> {
    const url = environment.chiliSauceApiRoot + `/api/DescribedItems/all`;
    return this.http.get<DescribedItemLookup>(url);
  }
}
